var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferedFlightManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:flight-roster"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 33",
    d: "M14.9873 4.95999H6.20094C5.5161 4.95999 4.96094 5.51516 4.96094 6.19999V14.3476C4.96094 14.6875 5.10046 15.0125 5.34689 15.2466L16.4847 25.8276C16.9722 26.2907 17.7401 26.2809 18.2156 25.8054L26.4041 17.6168C26.8884 17.1326 26.8884 16.3474 26.4041 15.8632L15.8641 5.32318C15.6316 5.09063 15.3162 4.95999 14.9873 4.95999Z",
    stroke: "#4A4A4A",
    strokeWidth: 2.0832
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28",
    cx: 9.91969,
    cy: 9.91999,
    r: 1.24,
    fill: "#4A4A4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferedFlightManagement);
export default __webpack_public_path__ + "static/media/offered-flight-management.88d6923662900a9295c780beb07fc79e.svg";
export { ForwardRef as ReactComponent };